<template>
	<div
		:class="
			cn(
				props.containerClass,
				'flex w-full gap-5 md:gap-6 md:items-center md:justify-center'
			)
		"
	>
		<Button
			v-for="tab in tabs"
			:key="tab.id"
			:variant="tab.active ? 'primary' : 'secondary'"
			class="flex w-full select-none items-center gap-3 border-0 border-b-2 border-transparent! bg-none px-0! pt-2 text-base ring-0! md:py-2"
			:class="
				cn(
					props.class,
					tab.active
						? 'border-primary! bg-white! text-primary'
						: 'border-white-dark-4 bg-white text-primary-light-4 hover:border-primary'
				)
			"
			@click="handleTabClick(tab.id)"
		>
			{{ tab.label }}
		</Button>
	</div>
</template>

<script setup lang="ts" generic="T extends string = Tab">
import type { NavigationTab, Tab } from '.';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{
	tabs: NavigationTab<T>[];
	class?: HTMLAttributes['class'];
	containerClass?: HTMLAttributes['class'];
}>();

const emit = defineEmits<{
	(e: 'tab-clicked', tabId: T): void;
}>();

const activeTabId = defineModel<T | null>();

function handleTabClick(tabId: T) {
	activeTabId.value = tabId === activeTabId.value ? null : tabId;
	emit('tab-clicked', tabId);
}
</script>
